var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g(_vm._b({staticClass:"svg-inline--fa fill-current",attrs:{"name":_vm.icon,"aria-hidden":"true","focusable":"false","role":"img","xmlns":"http://www.w3.org/2000/svg","viewBox":_vm.viewbox},domProps:{"innerHTML":_vm._s(_vm.iconoSVG)}},'svg',{ ..._vm.$attrs },false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }